import Link from 'next/link'
import styles from './ua.module.scss'

export default function TileInfo(props) {

  if (props.link) {
    return <Link href={props.link} className={styles.info} prefetch={false}>
      { props.children }
    </Link>
  } else {
    return <div className={styles.info}>
      { props.children }
    </div>
  }
  
}